// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function --experiment unified-ui-sidebar --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
// Note: The following attributes are automatically provided by the experiment provider
// and do not need to be passed as parameters: userEmail
export const useUnifiedUiSidebarVariation = makeBooleanFlagValueHook('unified-ui-sidebar');
//# sourceMappingURL=useUnifiedUiSidebarVariation.js.map